import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import CommonImagePreview from '../components/CommonImagePreview';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

const ATTACH_FILE_CONTENT_URL = `api/master/attach_files/files`;

class DataTableTypeAStudentImportFile extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    render() {

        let props = this.props;

        let { onSetEdit, onPreviewFile, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Masterbase, UserCookie} = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let fileType = options.category.type_a_student_import_file_type.options;

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-auto-max"></th>
                                        <th className="th-width-200p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            <Form.Check 
                                                type="checkbox"
                                                checked={Deletes.checkAll}
                                                onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {

                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                        
                                        rowId++;

                                        let del = true;

                                        if(row.status === '2'){ del = false; }

                                        let file_type = fileType.find(option => option.id === row.file_type)?.label;
;
                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>                                                   
                                                    <td className="text-truncate" >
                                                        {row.name}

                                                        {(row.import_date) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                <i className="fa-classic fa-light fa-clock fa-fw me-2"></i>วันที่นำเข้า {util.convertDateToTextBE(row.import_date, true)}
                                                            </p>
                                                        )}  

                                                        {!util.isEmpty(row.import_data_file_id) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                <i className="fa-classic fa-light fa-cloud-arrow-up fa-fw me-2"></i> 
                                                                ไฟล์นำเข้า
                                                                <span className="title-xs ms-2 mb-0 text-primary"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={(e) => onPreviewFile({id: row.import_data})}                                                                        
                                                                >
                                                                {row.import_data_file_name}
                                                                </span>
                                                            </p>
                                                        )}                                                           

                                                        <p className="mt-2">
                                                            <Badge className="badge-md" pill bg="primary">{file_type}</Badge>                                                        
                                                        </p>
                                                    </td>                                                     
                                                    <td>
                                                        <CommonDropdown
                                                            element="DataTable"
                                                            input={{id: 'status', value: row.status}}
                                                            option={{source: 'options', section: 'status', item: 'type_a_student_import_file'}}
                                                            callback={(e, element) => onDropDownChange(e, element, {key: 'id', value: row.id} )} 
                                                            disabled={!['0','1'].includes(UserCookie.types)}
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableTypeAStudentImportFile;
